module.exports = __webpack_public_path__ + "static/media/pembroke.41a93bc7.png";